import { createHash } from 'crypto'
import { ICMSBrand } from '~/models/components/BrandList'

export const hashBrands = (brands: ICMSBrand[]): string => {
  return createHash('md5')
    .update(brands.map(b => b.slug).join('-'))
    .digest('hex')
}
